export default __webpack_public_path__ + "static/media/tccontrolLogo.1ed0ce75.png";